import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { Level } from '@ascschool/model/category/level.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { PopUpCoSoComponent } from './pop-up-co-so/pop-up-co-so.component';
import { ThemCoSoComponent } from './them-co-so/them-co-so.component';
import { XemCoSoComponent } from './xem-co-so/xem-co-so.component';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { SchoolImportPupupComponent } from './import-co-so/pop-up-import-co-so.component';
import { DistrictService } from '@ascschool/services/category/district.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { WardService } from '@ascschool/services/category/ward.service';
@Component({
  selector: 'app-co-so',
  templateUrl: './co-so.component.html',
  styleUrls: ['./co-so.component.scss']
})
export class CoSoComponent implements OnInit, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  heightModal: string;
  widthModal: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  listDVGL: any[];
  listDVQLSelected: number[];
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  disableTinh : boolean;
  disableHuyen : boolean;
  getSoGDACFn: (value: any) => Observable<any>; SoGDSubscription: any; SoGDControl = new FormControl();
  getProvinceACFn: (value: any) => Observable<any>; provinceSubscription: any; provinceControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>; districtSubscription: any; districtControl = new FormControl();
  getWardACFn: (value: any) => Observable<any>; WardSubscription: any; WardControl = new FormControl();
  getSchoolLevelACFn: (value: any) => Observable<any>; SchoolLevelSubscription: any; SchoolLevelControl = new FormControl();
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private modalService: NzModalService, private authQuery: AuthQuery,
    private provinceService: ProvinceService, private districtService: DistrictService, private wardService: WardService,
    private service: SchoolService, public utilsService: UtilsService, private schoollevelService: SchoolLevelService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
   }
  get breadcrumbs(): string[] {
    return ['Quản lý đơn vị'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  currentUser : any;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[1];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  listData: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  divisibleForFour: boolean;
  sortNameFn = (a: Level, b: Level) => a.levelName.localeCompare(b.levelName);
  ngOnInit() {

    if (this.currentUser.accountType === 3) {
      this.disableTinh = true;
      this.disableHuyen = true;
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    if (this.currentUser.accountType === 3) {
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });

        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.districtSubscription) {
          this.districtSubscription = this.districtControl.valueChanges.subscribe(() => {
            this.utilsService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
          });
        }
      });

      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.districtControl.setValue({ id: response.id, text: response.districtName });
      });
    }
    if (this.currentUser.accountType === 1) {
      this.disableTinh = true;
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.districtSubscription) {
          this.districtSubscription = this.districtControl.valueChanges.subscribe(() => {
            this.utilsService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
          });
        }
      });
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.disableTinh = true;
      this.disableHuyen = true;
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.districtSubscription) {
          this.districtSubscription = this.districtControl.valueChanges.subscribe(() => {
            this.utilsService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
          });
        }
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.districtControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.loadWard();
        });
      });
    }

    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[1];
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    if (this.isCollapse) {
      this.divisibleForFour = this.isDivisibleForFour(4);
    } else {
      this.divisibleForFour = this.isDivisibleForFour(12);
    }
    this.loadProvince();
    this.loadSchoolLevel();
  }
  reload() {
    this.loading = true;
    this.checked = false;
    this.service.getAll(this.commonFilter).subscribe((response: any) => {
      this.Total = response.rowCount;
      this.firstRowOnPage = response.firstRowOnPage;
      this.listData = response.results ? response.results : [];
      this.loading = false;
      this.listData.map(x => x.checked = false);
      this.listDVQLSelected = [];
    }, (err: any) => {
      this.listData = [];
      this.listDVQLSelected = [];
      this.loading = false;
    });
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.provinceSubscription) {
      this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
      });
    }
  }
  changeProvince(control: FormControl) {
    if (control.value) {
      this.provinceControl = control;
      this.loadDistrict();
    }
    this.districtControl.setValue(null);
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.districtSubscription) {
      this.districtSubscription = this.districtControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.districtControl.value);
      });
    }
  }
  changeDistrict(control: FormControl) {
    if (control.value) {
      this.districtControl = control;
      this.loadWard();
    }
    this.WardControl.setValue(null);
  }

  loadWard() {
    this.getWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, districtId: this.valueIfHas(this.districtControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.WardSubscription) {
      this.WardSubscription = this.WardControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.WardControl.value);
      });
    }
  }

  changeWard(control: FormControl) {
    if (control.value) {
      this.WardControl = control;
    }
  }

  loadSchoolLevel() {
    this.getSchoolLevelACFn = (value: any) => this.schoollevelService.getSchoolLevelsSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.schoolLevelName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.SchoolLevelSubscription) {
      this.SchoolLevelSubscription = this.SchoolLevelControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'SchoolLevelId', this.SchoolLevelControl.value);
      });
    }
  }
  changeSchoolLevel(control: FormControl) {
    if (control.value) {
      this.SchoolLevelControl = control;
    }
  }

  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'], label: 'Help', description: 'Cmd + b', command: (e) => this.add(), preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {

      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void { }

  //popup
  add() {
    this.isResizdePopup = false;
    this.titlePopup = 'Thêm mới - thông tin cơ sở';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement, nzContent: ThemCoSoComponent,
      nzStyle: { top: '30px' }, nzMaskClosable: false,
      nzBodyStyle: { overflow: 'auto', height: this.heightModal, maxheight: this.heightModal },
      nzComponentParams: { dataTransmission: this.commonFilter },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }

  edit(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Sửa - thông tin cơ sở';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement, nzContent: PopUpCoSoComponent,
      nzStyle: { top: '30px' }, nzMaskClosable: false,
      nzBodyStyle: { overflow: 'auto', height: this.heightModal, maxheight: this.heightModal },
      nzComponentParams: { dataTransmission: item.id }, nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }
  view(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Xem - thông tin cơ sở';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement, nzContent: XemCoSoComponent,
      nzStyle: { top: '30px' }, nzMaskClosable: false,
      nzBodyStyle: { overflow: 'auto', height: this.heightModal, maxheight: this.heightModal },
      nzComponentParams: { dataTransmission: item.id }, nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe((results) => {
      if (results) {
        this.reload();
      }
    });
  }
  deleteMulti(): void {
    this.listDVQLSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listDVQLSelected.push(item);
    });
    if (this.listDVQLSelected.length > 0) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Xóa cơ sở', nzContent: ConfirmComponent,
        nzComponentParams: { description: 'cơ sở đã chọn' },
        nzStyle: { top: '20px' }, nzMaskClosable: false,
      });
      dialogRef.afterClose.subscribe(results => {
        if (results) {
          this.service.deleteMulti(this.listDVQLSelected).subscribe((res: any) => {
            this.msg.success('Cập nhật thông tin ' + res.message);
            this.reload();
          });
        }
      });
    } else {
      this.msg.warning('Bạn chưa chọn dữ liệu cần xóa');
    }
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  clear() {
    delete this.commonFilter.EducationAndTrainingCode;
    delete this.commonFilter.EducationAndTrainingName;
    delete this.commonFilter.Director;
    if(this.currentUser.accountType === 5 || this.currentUser.accountType === 6){
      this.provinceControl.setValue(null);
      this.districtControl.setValue(null);
      this.WardControl.setValue(null);
    }else if(this.currentUser.accountType === 1){
      this.districtControl.setValue(null);
      this.WardControl.setValue(null);
    }else if(this.currentUser.accountType === 2){
      this.WardControl.setValue(null);
    }
    this.SchoolLevelControl.setValue(null);
    this.reload();
  }
  exportExcel() {
    this.service.exportExcel(this.commonFilter).subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'DanhSachCoso.xlsx';
      link.click();
    });
  }
  handlerResizePopup() {
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height = this.heightModal;
    let top = 30;
    if (this.isResizdePopup === true) {
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width, nzStyle: { top: top + 'px', },
      nzBodyStyle: { overflow: 'auto', maxheight: height, height: height, }
    });
  }

  ImportData(): void {
    // if (this.commonFilter.SchoolId) {
    const dialogRef = this.modalService.create({
      nzTitle: 'Import Cơ sở', nzContent: SchoolImportPupupComponent,
      nzStyle: { top: '30px' }, nzMaskClosable: false, nzBodyStyle: { overflow: 'auto', },
      nzComponentParams: { schoolId: this.commonFilter.SchoolId, }, nzWidth: 700
    });
    // const instance = dialogRef.getContentComponent();
    dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.reload();
      }
    });
    // } else {
    //   this.msg.warning('Vui lòng chọn Cơ sở!');
    // }
  }
}
